import type { IChecklistItem } from './types.js';

/**
 * Items many programs share, so each program file stays short. Each takes the program's own
 * source index (the page that asks for it) and the roles it applies to.
 */
export const common = {
  passport: (source: number, forRoles: string[]): IChecklistItem => ({
    id: 'passport', label: 'Passport or travel document (copy of the information pages)', section: 'Identity and civil documents', forRoles, source,
    hint: 'Check the expiry date: a passport expiring within 6 months may need renewing first.'
  }),
  photos: (source: number, forRoles: string[]): IChecklistItem => ({
    id: 'photos', label: 'Photos (to IRCC specifications)', section: 'Photos and police certificates', forRoles, source
  }),
  police: (source: number, forRoles: string[]): IChecklistItem => ({
    id: 'police', label: 'Police certificates', section: 'Photos and police certificates', forRoles, minAge: 18, source, translationIfNotEnFr: true,
    hint: 'One for each country (other than Canada) where the person spent 6 or more months in a row since age 18. Not needed for Canadian citizens or permanent residents.'
  }),
  birth: (source: number, forRoles: string[]): IChecklistItem => ({
    id: 'birth', label: 'Birth certificate', section: 'Identity and civil documents', forRoles, source, translationIfNotEnFr: true
  }),
  representative: (source: number): IChecklistItem => ({
    id: 'imm5476', label: 'Use of a Representative', form: 'IMM 5476', section: 'Forms', forRoles: 'application', source,
    hint: 'Signed by the client and by the firm\'s representative.'
  }),
  fees: (source: number): IChecklistItem => ({
    id: 'fees', label: 'Proof of payment of the government fees', section: 'Fees', forRoles: 'application', source
  }),
  translations: (source: number): IChecklistItem => ({
    id: 'translations', label: 'Translations of documents not in English or French, with the translator\'s affidavit', section: 'Identity and civil documents', forRoles: 'application', source,
    hint: 'Not by the applicant or a family member. A Canadian certified translator doesn\'t need an affidavit. Include a certified copy of the original.'
  })
};
